import { useEffect, useState } from "react";
import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Convert API product (snake_case) → UI product (camelCase, matches old products.js schema)
export const mapProduct = (p) => ({
  id: p.product_id,
  slug: p.slug,
  title: p.title,
  subtitle: p.subtitle,
  brand: p.brand,
  category: p.category,
  mrp: p.mrp,
  sale: p.sale,
  rating: p.rating,
  reviews: p.reviews,
  badge: p.badge,
  color: p.color,
  material: p.material,
  aboutItem: p.about_item || [],
  description: p.description || "",
  keyFeatures: p.key_features || [],
  images: p.images || [],
  videoUrl: p.video_url || "",
  amazonUrl: p.amazon_url || "",
  stock: p.stock,
  active: p.active,
});

export const useCatalog = () => {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const [p, c] = await Promise.all([
          axios.get(`${API}/products`),
          axios.get(`${API}/categories`),
        ]);
        if (!cancelled) {
          setProducts(p.data.map(mapProduct));
          setCategories(c.data);
        }
      } catch (e) {
        if (!cancelled) setError(e.message);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return { products, categories, loading, error };
};

export const useProduct = (slug) => {
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    (async () => {
      try {
        const r = await axios.get(`${API}/products/${slug}`);
        if (!cancelled) setProduct(mapProduct(r.data));
      } catch (e) {
        if (!cancelled) setError(e?.response?.data?.detail || e.message);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [slug]);

  return { product, loading, error };
};

export const useBanners = (location) => {
  const [banners, setBanners] = useState([]);
  useEffect(() => {
    (async () => {
      try {
        const r = await axios.get(`${API}/banners`, { params: location ? { location } : {} });
        setBanners(r.data);
      } catch {
        setBanners([]);
      }
    })();
  }, [location]);
  return banners;
};
